import { tv } from "tailwind-variants";

const base = tv({
    base: "tw:block tw:w-fit tw:text-nowrap",

    variants: {
        size: {
            xs: "tw:text-xs tw:min-h-3.5 tw:leading-3.5",
            sm: "tw:text-xs tw:min-h-3.5 tw:leading-3.5",
            md: "tw:text-sm tw:min-h-4.5 tw:leading-4.5",
            lg: "tw:min-h-5 tw:leading-5",
            xl: "tw:min-h-6 tw:leading-6"
        }
    },

    defaultVariants: {
        size: "md"
    }
});

const price = tv({
    base: ["tw:font-bold"]
});

export const conversion = Object.assign(base, {
    price: price
});
